
import { mapGetters } from 'vuex';

export default {
  props: ['phone'],
  data() {
    return {
      openingHours: '08:00',
      closingHours: '00:00',
      openingHours2: '08:00',
      closingHours2: '22:00',
      clientReady: false,
      formattedTimes1: '8am - 12am (GMT)',
      formattedTimes2: '8am - 10pm (GMT)',
      isXmas: false,
      isNewYear: false,
    };
  },
  computed: {
    ...mapGetters({
      timeZone: 'geolocation/detectedTimezone',
      regionClicked: 'cart/getRegionClicked'
    }),
    phoneNumber() {
      // Your existing phone number logic
      if (this.regionClicked === 'TEFLORG') {
        return '<a href="tel:0330 808 9138">0330 808 9138</a>';
      } else if (this.regionClicked === 'IRELAND') {
        return '<a href="tel:+353 1 270 7964">+353 1 270 7964</a>';
      } else if (this.regionClicked === 'TEFLUS') {
        return '<a href="tel:888 897 2570">888.897.2570</a>';
      } else if (this.regionClicked === 'EU') {
        return '<a href="tel:+44 330 808 9138">+44 330 808 9138</a>';
      } else if (this.regionClicked === 'ROW') {
        return '<a href="tel:+1 888 897 2570">+1 888.897.2570</a>';
      }
      return '<a href="tel:+44 330 808 9138">+44 330 808 9138</a>';
    },
  },
  mounted() {
    // this.calculateOpeningHours();
  },
  methods: {
    calculateOpeningHours() {
    //   if (process.client) {
    //     const today = new Date();
    //     const year = today.getFullYear();
    //     const month = String(today.getMonth() + 1).padStart(2, '0');
    //     const day = String(today.getDate()).padStart(2, '0');
    //     const todayString = `${year}-${month}-${day}`;
    //     const londonZone = 'Europe/London';

    //     // Check for Christmas and New Year holidays
    //     this.isXmas = todayString > `${year}-12-24` && todayString < `${year}-12-27`;
    //     this.isNewYear = todayString > `${year}-12-31` && todayString < `${year+1}-01-02`;

    //     // Create Date objects for the opening times in London time
    //     const openingTimeLondon = new Date(new Intl.DateTimeFormat('en-US', {
    //         year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', timeZone: londonZone
    //     }).format(new Date(`${todayString}T${this.openingHours}:00`)));

    //     const openingTime2London = new Date(new Intl.DateTimeFormat('en-US', {
    //         year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', timeZone: londonZone
    //     }).format(new Date(`${todayString}T${this.openingHours2}:00`)));
        
    //     const closingTime1London = new Date(new Intl.DateTimeFormat('en-US', {
    //         year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', timeZone: londonZone
    //     }).format(new Date(`${todayString}T${this.closingHours}:00`)));

    //     const closingTime2London = new Date(new Intl.DateTimeFormat('en-US', {
    //         year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', timeZone: londonZone
    //     }).format(new Date(`${todayString}T${this.closingHours2}:00`)));

    //     // Use a fallback to 'UTC' if this.timeZone is not a valid timezone string
    //     const userTimeZone = this.timeZone || 'Europe/London';

    //     // Use Intl.DateTimeFormat to format the times in the user's timezone
    //     const timeZoneFormatter = new Intl.DateTimeFormat('en-US', {
    //       hour: 'numeric',
    //       minute: '2-digit',
    //       timeZone: userTimeZone,
    //       timeZoneName: 'short'
    //     });

    //     // Check if the current time in London falls within BST
    //     const londonOffset = new Date().toLocaleString('en-US', { timeZoneName: 'short', timeZone: londonZone });
    //     const isBST = londonOffset.includes('+1');

    //     // console.log(`London Offset: ${londonOffset}, isBST: ${isBST}`);

    //     const formatTime = (dateObj, isLocalTime) => {
    //         const formatted = timeZoneFormatter.formatToParts(dateObj);
    //         const hour = formatted.find(part => part.type === 'hour').value;
    //         const minute = formatted.find(part => part.type === 'minute').value;
    //         const dayperiod = formatted.find(part => part.type === 'dayPeriod').value.toLowerCase();
    //         let zone = formatted.find(part => part.type === 'timeZoneName').value;

    //         // Conditionally change the timezone display for BST
    //         if (isLocalTime && isBST && zone.includes('GMT')) {
    //             // console.log('Adjusting timezone display for BST');
    //             zone = 'BST';
    //         }
          
    //         return `${hour}:${minute}${dayperiod} (${zone})`;
    //     };

    //     const startFormatted1 = formatTime(openingTimeLondon, true);
    //     const closingFormatted1 = formatTime(closingTime1London, true);
    //     const startFormatted2 = formatTime(openingTime2London, true);
    //     const closingFormatted2 = formatTime(closingTime2London, true);

    //     this.formattedTimes1 = `${startFormatted1.replace(':00', '').replace('am', 'am ').replace('pm', 'pm ')} - ${closingFormatted1.replace(':00', '').replace('am', 'am ').replace('pm', 'pm ')}`;
    //     this.formattedTimes2 = `${startFormatted2.replace(':00', '').replace('am', 'am ').replace('pm', 'pm ')} - ${closingFormatted2.replace(':00', '').replace('am', 'am ').replace('pm', 'pm ')}`;
        
    //     this.clientReady = true;
    //   }
    }
  }
};
